export default "__VITE_ASSET__a961adab__"